<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" :disabled="showBigButtons" @click="cancel()">{{ (showBigButtons) ? "" : t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ t("Puzzle Rating") }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="showBigButtons" @click="confirm()" :strong="true">{{ (showBigButtons) ? "" : t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>


    <div v-show="showBigButtons" id="header">
      <ion-grid>
        <ion-row >
          <ion-col size="6">
            <ion-button  class="general-big-button cancel-button-color done-button-width" @click="cancel()">{{ t("Cancel") }}</ion-button>      
          </ion-col>
          <ion-col size="6">
            <ion-button class="general-big-button done-button-color done-button-width" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>  
  </ion-header>

  <ion-content class="ion-padding">
    <div id="page">
      <ion-item> 
        <ion-toggle label-placement="end" :checked="showRange" @ionChange="toggleChange">
          <span class="ion-text-wrap">{{ toggleLabel }}</span>
        </ion-toggle>
      </ion-item>
      <div v-show="!showRange">
        <ion-item>
          <ion-label class="ion-text-center">
            {{ t("Starting Rating") }}: {{ puzzleRatingNumber }}
          </ion-label>
        </ion-item>
        <ion-item v-show="!showRange">
          <ion-range id="single" aria-label="Range"   
                    pin="true"
                    v-model="puzzleRatingNumber"
                    :min="600" :max="2800"
                    @ionChange="puzzleRatingChange">
          </ion-range>
        </ion-item>
      </div>
      <div v-show="showRange">
        <ion-item>
          <ion-label class="ion-text-center">
          {{ t("Rating") }}: {{ minNumber }} {{ t("to") }} {{  maxNumber  }} / {{ t("Count") }}={{ puzzleTotal.toLocaleString() }}
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-range :pin="true" aria-label="Dual Knobs Range" :dual-knobs="true" :min="600" :max="2800" :step="100"   v-model="value"
                              @ionKnobMoveStart="onIonKnobMoveStart"
                              @ionKnobMoveEnd="onIonKnobMoveEnd">
          </ion-range>
        </ion-item>
      </div>
    </div>
  </ion-content>
</template>

<script  setup>

  import {
    IonGrid,IonRow,IonCol,
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonToggle,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref, onMounted } from 'vue';
  import { useConnectionStore } from '@/stores/connectionStore';

  import { t } from '@/composables/translateText.js'

  const props = defineProps({
    ratingInfo : Object
	})

  const connectionStore = useConnectionStore()

  //console.log("ratingInfo",props.ratingInfo)

  var didChangeSomething = false

  var minNumber = ref(0)
  var maxNumber = ref(0)
  const puzzleRatingNumber = ref(1600)
  const showRange = ref(false)

  puzzleRatingNumber.value = props.ratingInfo.currentRating

  switch (props.ratingInfo.selectUserRating) {
    case 0 : // old - setup defaults for the other option
      if (props.ratingInfo.oldRatingRange == 0) {
        showRange.value = false
        minNumber.value = Math.floor(puzzleRatingNumber.value / 100) * 100
      }
      else {
        showRange.value = true
        minNumber.value = props.ratingInfo.oldRatingRange
      }
      maxNumber.value = minNumber.value + 100

      // old style always gets updated
      didChangeSomething = true
      break
    case 1 : // new, start with user rating
    case 2 : // new, start with range
      showRange.value = (props.ratingInfo.selectUserRating == 2)
      puzzleRatingNumber.value = props.ratingInfo.currentRating
      minNumber.value = props.ratingInfo.minRating
      maxNumber.value = props.ratingInfo.maxRating
      break
  }

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(props.forceBigButtons || whichMenu == "buttons" || connectionStore.getShowBigButtons)
  const scalePercentage = connectionStore.getToolbarScalePercentage

  const radioButtonHeight = 30
  const useRadioButtonHeight = (showBigButtons.value) ? Math.floor( radioButtonHeight * scalePercentage / 100.0) :
                radioButtonHeight
  const doneButtonHeight = 50
  const useDoneButtonHeight = (showBigButtons.value) ? Math.floor( doneButtonHeight * scalePercentage / 100.0) :
                doneButtonHeight

  const toggleRangeLabel = t("Puzzles will be randomly selected from this rating range")
  const toggleSingleLabel = t("Puzzles will start at this rating and drift up/down based on success")
  const toggleLabel = ref((showRange) ? toggleRangeLabel : toggleSingleLabel)

  const puzzleTotal = ref(0)

  var value = {lower: minNumber.value, upper: maxNumber.value, 
            showRange: showRange.value, singleRating : puzzleRatingNumber.value }

  const cancel = () => modalController.dismiss(null, 'cancel');
  const confirm = () => modalController.dismiss(value, (didChangeSomething) ? 'confirm' : 'cancel');

  generateCounts()
  
  //console.log("toggle label",toggleLabel.value)

  function puzzleRatingChange({ detail }) {
    puzzleRatingNumber.value = detail.value
    //console.log("rating",detail,detail.value,puzzleRatingNumber.value)
    didChangeSomething = true

    value = {lower: minNumber.value, upper: maxNumber.value, 
        showRange: showRange.value, singleRating : puzzleRatingNumber.value }
  }

   function toggleChange({ detail }) {
    didChangeSomething = true
    showRange.value = detail.checked
    //console.log("toggle change",detail,detail.value,showRange.value)
    toggleLabel.value = (detail.checked) ? toggleRangeLabel : toggleSingleLabel

    value = {lower: minNumber.value, upper: maxNumber.value, 
            showRange: showRange.value, singleRating : puzzleRatingNumber.value }
  }

  function generateCounts() {
    const firstIndex = (minNumber.value - 600) / 100
    const lastIndex = (maxNumber.value - 600) / 100
    puzzleTotal.value = 0
    for (var i=firstIndex; i < lastIndex; i++)
      puzzleTotal.value += props.ratingInfo.puzzleCounts[i]
  }

  function onIonKnobMoveStart({ detail }) {
    didChangeSomething = true
    //console.log('ionKnobMoveStart:', detail.value);
    minNumber.value = (detail.value.lower == 2800) ? 2700 : detail.value.lower
    maxNumber.value = detail.value.upper
    maxNumber.value = (detail.value.upper == detail.value.lower) ? detail.value.upper + 100 : detail.value.upper
    generateCounts()

    value = {lower: minNumber.value, upper: maxNumber.value, 
        showRange: showRange.value, singleRating : puzzleRatingNumber.value }
  }
  
  function onIonKnobMoveEnd({ detail }) {
    didChangeSomething = true
    //console.log('ionKnobMoveEnd:', detail.value)
    minNumber.value = detail.value.lower
    maxNumber.value = (detail.value.upper == detail.value.lower) ? detail.value.upper + 100 : detail.value.upper
    generateCounts()

    value = {lower: minNumber.value, upper: maxNumber.value, 
        showRange: showRange.value, singleRating : puzzleRatingNumber.value }
  }

  onMounted(() => {

    const single = document.getElementById("single");
    single.pinFormatter = (value) => {
      return `${value}`;
    };

    var element = document.getElementById("page")
    if (element != null) {
      element.style.setProperty("--toggle_button_height", useRadioButtonHeight + "px");
      element.style.setProperty("--toggle_button_width", (useRadioButtonHeight * 1.5) + "px");
    }
    element = document.getElementById("header")
    if (element != null)
      element.style.setProperty("--done_button_size", useDoneButtonHeight + "px");
  })


</script>

<style scoped>

  #page {
    --toggle_button_height : 30px;
    --toggle_button_width : 60px;
  }

  #header {
    --done_button_size : 50px;
  }

  .done-button-width {
    width : 100%;
  }
 
  ion-toggle::part(track) {
    width: var(--toggle_button_width);
    height: var(--toggle_button_height);
  }

    ion-range {
    --bar-height: 4px;
    --bar-border-radius: 4px;
    --knob-size: var(--toggle_button_height);
    margin-top : 10px;
    padding-top : var(--toggle_button_height);
    padding-bottom : var(--toggle_button_height);
  }

</style>
